module.exports = __webpack_public_path__ + "img/7.a30eb450.png";